<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <div class="row">
                        <div class="col-sm-12 col-lg-4">
                            <div class="card-body">
                                <h4 class="card-title">My Wallet</h4>
                                <h5 class="card-subtitle">Please keep your keys secure</h5>

                                <h2 class="font-medium m-t-40 m-b-0" v-if="balance">
                                    {{balance | money }}</h2>
                                <span class="text-muted">Account Balance</span>
                            </div>
                        </div>
                        <div class="col-sm-12 col-lg-8 border-left">
                            <div class="card-body">
                                <ul class="list-style-none">
                                    <li class="m-t-40" v-bind:key="index" v-for="(a, index) in addresses">
                                        <div class="d-flex align-items-center">
                                            <blockie :address="a.address" :width="64"></blockie>
                                            <div class="m-l-10">
                                                <h5 class="m-b-0 address">{{a.address}}</h5>
                                                &nbsp; <span class="label label-success" v-if="a.status === 'ACTIVE'">{{a.status}}</span>
                                                <span class="text-muted"></span>
                                                <div class="button-group float-right">
                                                    <button @click="copyToClipboard(a.address)" class="btn waves-effect waves-light btn-rounded btn-xs btn-light" data-placement="top"
                                                            data-toggle="tooltip"
                                                            title="Copy to clipboard"
                                                            type="button">
                                                        <i class="fas fa-copy"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title"><i class="fas fa-shopping-cart"></i> Purchase</h4>
                            </div>
                        </div>
                    </div>
                    <form @submit.prevent="handleSubmit()" class="form-horizontal">
                        <div class="card-body card-blue">
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="address">Wallet Address</label>
                                <div class="col-sm-6">
                                    <div :class="{'is-invalid': submitted && errors.has('address')}" class="form-control p-0-0">
                                        <multiselect
                                                :option-height="104"
                                                :options="addresses"
                                                :show-labels="false"
                                                data-vv-as="address"
                                                id="address"
                                                label="address"
                                                name="address"
                                                placeholder="Select wallet address"
                                                track-by="address"
                                                v-model="purchase.address"
                                                v-validate="'required'">
                                            <template slot="singleLabel" slot-scope="props">
                                                <div class="d-flex align-items-center">
                                                    <div class="m-l-2">
                                                        <blockie :address="props.option.address" :width="36" class="option__image"></blockie>
                                                    </div>
                                                    <div class="m-l-10">
                                                        <h5>{{ props.option.address }}</h5>
                                                    </div>
                                                </div>
                                            </template>
                                            <template slot="option" slot-scope="props">
                                                <div class="d-flex align-items-center">
                                                    <div class="m-l-2">
                                                        <blockie :address="props.option.address" :width="36" class="option__image"></blockie>
                                                    </div>
                                                    <div class="m-l-10">
                                                        <h5>{{ props.option.address }}</h5>
                                                    </div>
                                                </div>
                                            </template>
                                        </multiselect>
                                    </div>
                                    <div class="invalid-feedback" v-if="submitted && errors.has('address')">{{ errors.first('address') }}</div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="amount">Amount</label>
                                <div class="col-sm-6">
                                    <input :class="{'is-invalid': submitted && errors.has('amount')}"
                                           class="form-control"
                                           id="amount"
                                           name="amount"
                                           pattern="\d*"
                                           placeholder="Amount in USD"
                                           type="number"
                                           step="any"
                                           v-model="purchase.amount"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('amount')">{{ errors.first('amount') }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="form-group m-b-0 text-right">
                                <div class="button-group">
                                    <button class="btn waves-effect waves-light btn-success" type="submit">Purchase</button>
                                    <button @click="reset()" class="btn waves-effect waves-light btn-secondary" type="button">Reset</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from "../common/Blockie";
    import Multiselect from 'vue-multiselect';
    import _ from "lodash";
    import Money from "../../../models/Money";

    export default {
        name: "Wallet",
        components: {Blockie, Multiselect},
        data() {
            return {
                submitted: false,
                addresses: [],
                value: [],
                purchase: {
                    address: null,
                    amount: null
                },
                activeWalletId: null,
                balance: null
            }
        },
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        beforeMount() {
            console.log(this.currentUser)
            this.getAddresses();
        },
        methods: {
            getAddresses() {
                this.$http
                .get("/wallets/addresses")
                .then(response => {
                    if(response.data !== null) {
                        if(response.data.length > 0) {
                            this.addresses        = response.data;
                            this.purchase.address = _.find(this.addresses, {status: 'ACTIVE'});
                            this.activeWalletId   = _.find(this.addresses, {status: 'ACTIVE'}).id;
                            this.getBalance();
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            },
            copyToClipboard(textToCopy) {
                this.$copyText(textToCopy)
                .then(function(e) {
                }, function(e) {
                })
            },
            handleSubmit() {
                this.submitted = true;
                this.$validator.validate()
                .then(valid => {
                    if(valid) {
                        this.purchaseToken();
                    }
                });
            },
            async purchaseToken() {
                try {
                    $(".preloader").fadeIn();
                    await this.$http.post(`/wallets/${this.purchase.address.id}/purchase`, {
                        amount: this.purchase.amount
                    });
                    $(".preloader").fadeOut();
                    this.$toastr('success', 'Successfully purchased tokens', 'Success!');
                    this.reset();
                    this.getAddresses();
                } catch(e) {
                    $(".preloader").fadeOut();
                    console.dir(e);
                    this.$toastr('error', e.response.data.reason, 'Failed!');
                }
            },
            reset() {
                this.submitted = false;
                this.purchase  = {
                    address: this.addresses[0],
                    amount: null
                }
            },
            async getBalance() {
                if(this.activeWalletId) {
                    let balance  = await this.$http.get(`/wallets/${this.activeWalletId}/balance`, {
                        params: {
                            orgid: this.currentOrg.id
                        }
                    });
                    this.balance = balance.data;
                }
            }
        }
    }
</script>

<style scoped>
    h5.address {
        font-family: Source Code Pro, monospace;
        color: #4f5382;
        font-size: 16px;
    }

    .invalid-feedback {
        display: block;
    }
</style>
